import { application } from "~/controllers/application";

const getCustomSelectStyles = (isRequired, isInvalid, isDark = false) => {
  const menuBg = isDark ? "#1e293b" : "#ffffff";
  const menuHover = isDark ? "#334155" : "#f3f4f6";
  const menuText = isDark ? "#e5e7eb" : "#111827";
  const border = isDark ? "#334155" : "#d1d5db";
  const primary = isDark ? "#60a5fa" : "#3b82f6";
  const primaryHover = isDark ? "#1d4ed8" : "#2563eb";
  const surface = isDark ? "#0f172a" : "#ffffff";
  const surfaceHover = isDark ? "#1e293b" : "#f3f4f6";
  const textSecondary = isDark ? "#94a3b8" : "#6b7280";

  return {
    control: (provided, state) => ({
      ...provided,
      backgroundColor: surface,
      borderColor:
        isRequired && isInvalid && !state.isFocused
          ? "#ef4444"
          : state.isFocused
            ? primary
            : border,
      boxShadow:
        isRequired && isInvalid && !state.isFocused
          ? "0 0 0 1px #fef2f2"
          : state.isFocused
            ? `0 0 0 1px ${primary}`
            : provided.boxShadow,
      "&:hover": {
        borderColor:
          isRequired && isInvalid
            ? "#ef4444"
            : state.isFocused
              ? primary
              : border,
        backgroundColor: surfaceHover,
      },
    }),
    input: (base) => ({
      ...base,
      color: menuText,
      "input:focus": {
        boxShadow: "none",
      },
    }),
    menu: (base) => ({
      ...base,
      backgroundColor: menuBg,
      color: menuText,
      borderColor: border,
      zIndex: 105,
      boxShadow: isDark
        ? "0 10px 15px -3px rgba(0, 0, 0, 0.5)"
        : "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999,
    }),
    menuList: (base) => ({
      ...base,
      backgroundColor: menuBg,
      color: menuText,
      paddingTop: 4,
      paddingBottom: 4,
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected
        ? primaryHover
        : state.isFocused
          ? menuHover
          : menuBg,
      color: state.isSelected ? "#ffffff" : menuText,
      cursor: "pointer",
      ":active": {
        backgroundColor: primary,
      },
    }),
    placeholder: (base) => ({
      ...base,
      color: textSecondary,
    }),
    singleValue: (base) => ({
      ...base,
      color: menuText,
    }),
    multiValue: (base) => ({
      ...base,
      backgroundColor: menuHover,
      color: menuText,
    }),
    multiValueLabel: (base) => ({
      ...base,
      color: menuText,
    }),
  };
};

const connectControllers = (container, controllerName) => {
  requestAnimationFrame(() => {
    const elements = container.querySelectorAll(
      `[data-controller=${controllerName}]`,
    );

    elements.forEach((element) => {
      const tryConnect = (retries = 3) => {
        const controller = application.getControllerForElementAndIdentifier(
          element,
          controllerName,
        );

        if (controller) {
          if (!controller.isConnected) {
            controller.connect();
          }
        } else if (retries > 0) {
          setTimeout(() => tryConnect(retries - 1), 50);
        } else {
          console.warn(`Controller ${controllerName} not found after retries`);
        }
      };

      tryConnect();
    });
  });
};

export { getCustomSelectStyles, connectControllers };
